import { render, staticRenderFns } from "./PdfRenderArea.vue?vue&type=template&id=5efaa3a2&"
import script from "./PdfRenderArea.vue?vue&type=script&lang=js&"
export * from "./PdfRenderArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports